import React, { memo } from 'react';
import { SearchCore } from './parts';
import SearchIcon from '../../../public/images/icons/search-thin.svg';
import theme from '../../theme';
import {makeStyles} from '@material-ui/styles';


function Search() {
	return (
        <SearchCore />
	);
}

export default memo(Search);
